import { IStores } from "stores";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { NetworkType, WalletsWhitelistType } from "interfaces";
import * as services from "services";
import { runInAction } from "mobx";

export class WalletsWhitelistStore extends ListStoreConstructor<WalletsWhitelistType> {
  public walletAddress: string[] = [];

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getWalletsWhitelist(params).then((response: any) => {
          return {
            content: response.content || [],
            size: response.size || 0,
            totalPages: response.totalPages || 0,
            totalElements: response.totalElements || 0,
          } as any;
        });
      },
      {
        sorters: { statusDate: "desc" },
      }
    );
  }

  async addWalletsToWhitelist(wallets: string[], network: "ETH" | "TRX") {
    runInAction(() => {
      this.fetchStatus = "fetching";
      this.fetchError = undefined;
    });

    try {
      const response = await services.addWalletsToWhitelist({ destinationWallets: wallets, network: network });
      runInAction(() => {
        this.walletAddress = response;
        this.fetchStatus = "success";
      });
    } catch (error: any) {
      runInAction(() => {
        this.fetchStatus = "error";
        this.fetchError = error;
      });
      throw error;
    }
  }
}
